import React, { memo } from "react";
import { SearchDividerCellWrapper } from "./style";

const KTSearchDividerCell = memo(() => {
  return <SearchDividerCellWrapper></SearchDividerCellWrapper>;
});

export default KTSearchDividerCell;
